import Link from 'next/link'

interface UserNameProps {
  userId: string
  name: string | null
  className?: string
  // Accept the equipped cosmetics array directly from the parent
  cosmetics?: any[] 
}

export default function UserName({ userId, name, className = '', cosmetics = [] }: UserNameProps) {
  // Extract styles based on the type
  const textColors = cosmetics.filter(c => c?.item?.type === 'TEXT_COLOR').map(c => c.item.cssValue)
  const animations = cosmetics.filter(c => c?.item?.type === 'ANIMATION_EFFECT').map(c => c.item.cssValue)
  const badges = cosmetics.filter(c => c?.item?.type === 'BADGE').map(c => c.item.cssValue)

  // Merge them, defaulting to standard text if they have no cosmetics equipped
  const combinedStyles = [...textColors, ...animations].filter(Boolean).join(' ') || 'text-slate-100'
  const finalBadge = badges[0] || ''

  return (
    <Link href={`/user/${userId}`} className={`inline-flex items-center gap-1.5 font-bold hover:underline ${className}`}>
      <span className={combinedStyles}>
        {name || 'User'}
      </span>
      {finalBadge && <span className="text-xs">{finalBadge}</span>}
    </Link>
  )
}